import { render } from "./AttributeValue.vue?vue&type=template&id=217ec44c&scoped=true"
import script from "./AttributeValue.vue?vue&type=script&lang=js"
export * from "./AttributeValue.vue?vue&type=script&lang=js"

import "./AttributeValue.vue?vue&type=style&index=0&id=217ec44c&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-217ec44c"]])

export default __exports__